export default __webpack_public_path__ + "static/media/mesial-okklusal-distal.49afe86b.png";